import React from "react";
import Switch from "@mui/material/Switch";
import { styled } from "@mui/system";

const StyledSwitch = styled(Switch)(({ theme }) => ({
  width: 28,
  height: 16,
  padding: 0,
  display: "flex",
  "&:active": {
    "& .MuiSwitch-thumb": {
      width: 15,
    },
    "& .MuiSwitch-switchBase.Mui-checked": {
      transform: "translateX(9px)",
    },
  },
  "& .MuiSwitch-switchBase": {
    padding: 2,
    "&.Mui-checked": {
      transform: "translateX(12px)",
      color: theme?.palette?.common?.white || '#fff',
      "& + .MuiSwitch-track": {
        opacity: 1,
        backgroundColor: "#0069D7",
      },
    },
  },
  "& .MuiSwitch-thumb": {
    boxShadow: "0 2px 4px 0 rgb(0 35 11 / 20%)",
    width: 12,
    height: 12,
    borderRadius: 6,
    transition: theme?.transitions?.create(["width"], {
      duration: 200,
    }),
  },
  "& .MuiSwitch-track": {
    borderRadius: 16 / 2,
    opacity: 1,
    backgroundColor: "#616161",
    boxSizing: "border-box",
  },
}));

const CustomSwitch = ({ ...props }) => {
  return <StyledSwitch {...props} />;
};

export default CustomSwitch;
